/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

/* ===== Pre-Order Message Controller ==== */
  /*
  document.addEventListener('theme:variant:change', function(event) {
    console.log("🔥 theme:variant:change fired");
  
    var variant = event.detail.variant;
    var container = event.target;
  
    console.log("📦 Variant object:", variant);
    console.log("📦 Container element:", container);
  
    if (!variant) {
      console.log("⚠️ No variant found, skipping.");
      return;
    }
  
    const preorderColors = ["Aqua Blue", "Teal Aqua", "Blue Black", "Blue Purple", "Pink Aqua"];
    const preorderNote = document.getElementById("preorder-note");
  
    if (!preorderNote) {
      console.log("⚠️ Pre-order note element not found.");
      return;
    }
  
    // Log all options selected
    const selectedOptions = variant.options || [];
    console.log("🎯 Selected options:", selectedOptions);
  
    // Assuming color is the first option (update index if not)
    const selectedColor = selectedOptions[0] ? selectedOptions[0].trim() : "";
    console.log("🎨 Selected color:", selectedColor);
  
    const isPreorder = preorderColors.includes(selectedColor);
    console.log("📋 Is pre-order color?", isPreorder);
  
    preorderNote.style.display = isPreorder ? "inline-block" : "none";
  });

  
  document.addEventListener("DOMContentLoaded", function () {
    console.log("🌐 DOMContentLoaded fired");
  
    const variantIdInput = document.querySelector('input[name="id"]');
    const variantId = variantIdInput ? variantIdInput.value : null;
  
    if (!variantId) {
      console.log("⚠️ Variant ID not found on page load.");
      return;
    }
  
    console.log("🔁 Variant ID from page:", variantId);
  
    // Look for the embedded product JSON
    const productJsonEl = document.querySelector('script[type="application/json"][data-product-json]');
    if (!productJsonEl) {
      console.log("⚠️ Product JSON script tag not found.");
      return;
    }
  
    let productData;
    try {
      productData = JSON.parse(productJsonEl.textContent);
      console.log("📦 Parsed product data:", productData);
    } catch (e) {
      console.log("❌ Failed to parse product JSON:", e);
      return;
    }
  
    const allVariants = productData.variants || [];
    const preloadVariant = allVariants.find(v => String(v.id) === variantId);
  
    if (!preloadVariant) {
      console.log("⚠️ No matching variant found for ID.");
      return;
    }
  
    console.log("✅ Preloaded variant matched:", preloadVariant);
  
    const event = new CustomEvent('theme:variant:change', {
      detail: {
        variant: preloadVariant
      },
      bubbles: true
    });
  
    document.dispatchEvent(event);
  });
*/


  
  /*
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  */
  
  // Fired when page loads to update header values 
  /*
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });
 */
  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  /* ===== Bundler Checkout Button Fix ===== */
  // Corrects Bundler's displayed prices to account for Shopify discounts (like free items)
  // Watches Bundler's DOM updates and recalculates using correct Shopify totals

  const BUNDLER_FIX_CONFIG = {
    enabled: true,
    debug: false // Set to true to enable console logs
  };

  let isUpdating = false;
  let buttonObserver = null;
  let cachedCart = null; // Cache cart data to avoid fetch delays

  // Parse price from Bundler's HTML (e.g., "$67.90" -> 6790 cents)
  function parsePriceFromText(priceText) {
    if (!priceText) return 0;
    // Remove currency symbols, commas, and extract number
    const cleanPrice = priceText.replace(/[^0-9.]/g, '');
    const dollars = parseFloat(cleanPrice);
    return Math.round(dollars * 100); // Convert to cents
  }

  // Correct Bundler's displayed values
  function correctBundlerPrices() {
    if (!BUNDLER_FIX_CONFIG.enabled || isUpdating) return;

    const checkoutButton = document.querySelector('[data-cart-final]');
    if (!checkoutButton) return;

    // Check if Bundler has added its HTML (has bndlr-cart-values spans)
    const bundlerSpans = checkoutButton.querySelectorAll('.bndlr-cart-values');
    if (bundlerSpans.length < 2) {
      // Bundler hasn't updated yet, or no discount applied
      if (BUNDLER_FIX_CONFIG.debug) {
        console.log('Bundler Fix - No Bundler discount detected in DOM');
      }
      return;
    }

    isUpdating = true;

    // Extract Bundler's displayed values from the DOM
    const oldPriceSpan = checkoutButton.querySelector('.bndlr-cart-values-old-price');
    const newPriceSpan = checkoutButton.querySelector('.bndlr-cart-values:not(.bndlr-cart-values-old-price)');

    if (!oldPriceSpan || !newPriceSpan) {
      isUpdating = false;
      return;
    }

    const bundlerOldPrice = parsePriceFromText(oldPriceSpan.textContent); // Bundler's incorrect subtotal
    const bundlerNewPrice = parsePriceFromText(newPriceSpan.textContent); // Bundler's discounted price

    // Calculate Bundler's discount amount
    const bundlerDiscount = bundlerOldPrice - bundlerNewPrice;

    if (BUNDLER_FIX_CONFIG.debug) {
      console.log('Bundler Fix - Parsed from DOM:', {
        bundlerOldPrice: bundlerOldPrice / 100,
        bundlerNewPrice: bundlerNewPrice / 100,
        bundlerDiscount: bundlerDiscount / 100
      });
    }

    // Function to apply the correction
    function applyCorrection(cart) {
      const shopifyTotal = cart.total_price; // Correct total (includes free items at $0)
      const correctFinalPrice = shopifyTotal - bundlerDiscount;

      if (BUNDLER_FIX_CONFIG.debug) {
        console.log('Bundler Fix - Corrected calculation:', {
          shopifyTotal: shopifyTotal / 100,
          bundlerDiscount: bundlerDiscount / 100,
          correctFinalPrice: correctFinalPrice / 100
        });
      }

      // Format prices
      let formattedSubtotal, formattedFinalPrice;
      if (window.theme && window.themeCurrency && window.themeCurrency.formatMoney) {
        formattedSubtotal = window.themeCurrency.formatMoney(shopifyTotal, window.theme.moneyFormat);
        formattedFinalPrice = window.themeCurrency.formatMoney(correctFinalPrice, window.theme.moneyFormat);
      } else {
        formattedSubtotal = '$' + (shopifyTotal / 100).toFixed(2);
        formattedFinalPrice = '$' + (correctFinalPrice / 100).toFixed(2);
      }

      // Update the button with corrected values
      const currencyCode = window.theme && window.theme.currencyCode ? window.theme.currencyCode.toUpperCase() : 'AUD';
      const newContent = `<span class="bndlr-cart-values bndlr-cart-values-old-price bndlr-cross-out bndlr-money conversion-bear-money notranslate ht-money money" data-money-convertible="" data-currency-${currencyCode.toLowerCase()}="${formattedSubtotal}">${formattedSubtotal}</span>&nbsp;<span class="bndlr-cart-values bndlr-money conversion-bear-money notranslate ht-money money" data-money-convertible="" data-currency-${currencyCode.toLowerCase()}="${formattedFinalPrice}">${formattedFinalPrice}</span>`;

      // Disconnect observer before our update to prevent feedback loop
      if (buttonObserver) {
        buttonObserver.disconnect();
      }

      checkoutButton.innerHTML = newContent;

      // Reconnect observer after our update
      if (buttonObserver) {
        buttonObserver.observe(checkoutButton, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      if (BUNDLER_FIX_CONFIG.debug) {
        console.log('Bundler Fix - Updated button:', {
          from: `${oldPriceSpan.textContent} → ${newPriceSpan.textContent}`,
          to: `${formattedSubtotal} → ${formattedFinalPrice}`
        });
      }

      isUpdating = false;
    }

    // Use cached cart if available, otherwise fetch
    if (cachedCart) {
      if (BUNDLER_FIX_CONFIG.debug) {
        console.log('Bundler Fix - Using cached cart data');
      }
      applyCorrection(cachedCart);
    } else {
      if (BUNDLER_FIX_CONFIG.debug) {
        console.log('Bundler Fix - Fetching cart data');
      }
      fetch(window.theme.routes.cart + '.js')
        .then(response => response.json())
        .then(cart => {
          cachedCart = cart; // Cache for next time
          applyCorrection(cart);
        })
        .catch(err => {
          if (BUNDLER_FIX_CONFIG.debug) {
            console.error('Bundler Fix - Error fetching cart:', err);
          }
          isUpdating = false;
        });
    }
  }

  // Watch for Bundler updating the checkout button
  function watchCheckoutButton() {
    const checkoutButton = document.querySelector('[data-cart-final]');
    if (!checkoutButton) return;

    // Disconnect existing observer
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer
    buttonObserver = new MutationObserver(function(mutations) {
      // Bundler updated the button, wait a moment then correct it
      setTimeout(correctBundlerPrices, 50);
    });

    // Start observing
    buttonObserver.observe(checkoutButton, {
      childList: true,
      subtree: true,
      characterData: true
    });

    if (BUNDLER_FIX_CONFIG.debug) {
      console.log('Bundler Fix - Now watching checkout button for Bundler updates');
    }
  }

  // Initialize
  if (BUNDLER_FIX_CONFIG.enabled) {
    // Listen for cart changes to keep cache updated
    document.addEventListener('theme:cart:change', function(event) {
      if (event.detail && event.detail.cart) {
        cachedCart = event.detail.cart;
        if (BUNDLER_FIX_CONFIG.debug) {
          console.log('Bundler Fix - Cart cache updated');
        }
      }
    });

    // Listen for initial cart load
    document.addEventListener('theme:cart:init', function(event) {
      if (event.detail && event.detail.cart) {
        cachedCart = event.detail.cart;
        if (BUNDLER_FIX_CONFIG.debug) {
          console.log('Bundler Fix - Initial cart cached');
        }
      }
    });

    // Watch button when Bundler loads
    document.addEventListener('bundler:loaded', function() {
      if (BUNDLER_FIX_CONFIG.debug) {
        console.log('Bundler Fix - Bundler loaded');
      }
      watchCheckoutButton();
      setTimeout(correctBundlerPrices, 50);
    });

    // Watch when Bundler recalculates
    document.addEventListener('bundler:total_cart_values', function() {
      if (BUNDLER_FIX_CONFIG.debug) {
        console.log('Bundler Fix - Bundler recalculated');
      }
      setTimeout(correctBundlerPrices, 50);
    });

    // Watch when drawer opens
    document.addEventListener('DOMContentLoaded', function() {
      const drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) {
        drawer.addEventListener('theme:drawer:open', function() {
          if (BUNDLER_FIX_CONFIG.debug) {
            console.log('Bundler Fix - Drawer opened');
          }
          watchCheckoutButton();
          setTimeout(correctBundlerPrices, 50);
        });
      }
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

})();
